module.exports = __webpack_public_path__ + "img/noEvents.d2f3364c.svg";